import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Mounts the native offscreen passes for every Control-only sub-viewport
 * (ADR-0033), for both canvases, since a consumer in either may sample one. The
 * Control renderer loads lazily, and only for a scene that has such a viewport.
 */
import { lazy } from 'react';
import { PendingSuspense } from '../../../resources/PendingSuspense.js';
import { useControlRasterViewports } from './useControlRasterViewports.js';
const ControlRasterPasses = lazy(() => import('./ControlRasterPass.js').then((m) => ({ default: m.ControlRasterPasses })));
export function ControlRasterLayer({ nodes, internalResources, externalResources }) {
    const viewports = useControlRasterViewports(nodes, internalResources, externalResources);
    if (viewports.length === 0)
        return null;
    return (_jsx(PendingSuspense, { children: _jsx(ControlRasterPasses, { viewports: viewports }) }));
}
//# sourceMappingURL=ControlRasterLayer.js.map